
import { createContext } from 'react';
import User from '../../models/User';
const AuthenticationContext = createContext<User | null>(null);

export default AuthenticationContext;
